import {ACTION_TYPE_HIDE_JCAPTCHA, ACTION_TYPE_REFRESH_JCAPTCHA, ACTION_TYPE_SHOW_JCAPTCHA} from '../actions/unoCaptcha'

export const unoCaptcha = (states = {}, action) =>{
    const captchaName = action.unoCaptchaName;
    const fieldCaptcha = captchaName && states[captchaName] ? states[captchaName] : {};

    switch (action.type){
        case ACTION_TYPE_SHOW_JCAPTCHA:
            const result1 = {...states};
            result1[captchaName] = {...fieldCaptcha, showJcaptcha: true};
            return result1;
        case ACTION_TYPE_HIDE_JCAPTCHA:
            const result2 = {...states};
            result2[captchaName] = {...fieldCaptcha, showJcaptcha: false};
            return result2;
        case ACTION_TYPE_REFRESH_JCAPTCHA:
            const result3 = {...states};
            result3[captchaName] = {...fieldCaptcha, jcaptchaImageRandomizer: (new Date()).getTime()};
            return result3;
        default:
            return states;
    }
}